<!--
/**
 * OrangeHRM is a comprehensive Human Resource Management (HRM) System that captures
 * all the essential functionalities required for any enterprise.
 * Copyright (C) 2006 OrangeHRM Inc., http://www.orangehrm.com
 *
 * OrangeHRM is free software: you can redistribute it and/or modify it under the terms of
 * the GNU General Public License as published by the Free Software Foundation, either
 * version 3 of the License, or (at your option) any later version.
 *
 * OrangeHRM is distributed in the hope that it will be useful, but WITHOUT ANY WARRANTY;
 * without even the implied warranty of MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.
 * See the GNU General Public License for more details.
 *
 * You should have received a copy of the GNU General Public License along with OrangeHRM.
 * If not, see <https://www.gnu.org/licenses/>.
 */
-->

<template>
  <div
    v-if="visible"
    :class="[
      'orangehrm-break-controls',
      compact ? 'orangehrm-break-controls--compact' : '',
      isOnBreak ? 'orangehrm-break-controls--on-break' : '',
    ]"
  >
    <div class="orangehrm-break-controls__status">
      <span
        :class="[
          'orangehrm-break-controls__indicator',
          isOnBreak
            ? 'orangehrm-break-controls__indicator--break'
            : 'orangehrm-break-controls__indicator--active',
        ]"
      />
      <oxd-text tag="span" class="orangehrm-break-controls__status-label">
        {{
          isOnBreak ? $t('attendance.on_break') : $t('attendance.punched_in')
        }}
      </oxd-text>
    </div>

    <button
      v-if="!isOnBreak"
      type="button"
      class="orangehrm-break-controls__btn orangehrm-break-controls__btn--pause"
      :disabled="disabled"
      @click="$emit('pause')"
    >
      <oxd-icon
        name="pause-circle-fill"
        class="orangehrm-break-controls__btn-icon"
      />
      <span class="orangehrm-break-controls__btn-label">
        {{ $t('attendance.pause') }}
      </span>
    </button>

    <button
      v-else
      type="button"
      class="orangehrm-break-controls__btn orangehrm-break-controls__btn--resume"
      :disabled="disabled"
      @click="$emit('resume')"
    >
      <oxd-icon
        name="play-circle-fill"
        class="orangehrm-break-controls__btn-icon"
      />
      <span class="orangehrm-break-controls__btn-label">
        {{ $t('attendance.resume') }}
      </span>
    </button>
  </div>
</template>

<script>
import {OxdIcon} from '@ohrm/oxd';

export default {
  name: 'BreakControls',

  components: {
    'oxd-icon': OxdIcon,
  },

  props: {
    isOnBreak: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    visible: {
      type: Boolean,
      default: true,
    },
    compact: {
      type: Boolean,
      default: false,
    },
  },

  emits: ['pause', 'resume'],
};
</script>

<style src="./break-controls.scss" lang="scss" scoped></style>
